import { Check } from '@mui/icons-material';

import { McpClientIcon } from 'components/shared/bumperMcp/McpClientIcon';

import { ASSISTANT_CAPABILITIES, MCP_CLIENTS } from '../constants';

import {
  CapabilitiesLabel,
  CapabilityRow,
  CapabilityText,
  ClientCard,
  ClientGrid,
  ClientName,
  GetStartedButton,
  HeroRoot,
  SectionText,
  SectionTitle,
  StatusPill,
} from './styledComponents';

interface HeroSectionProps {
  onGetStartedClick: () => void;
}

export const HeroSection = ({ onGetStartedClick }: HeroSectionProps) => (
  <HeroRoot>
    <SectionTitle>
      Run Bumper reports without leaving your AI assistant
    </SectionTitle>
    <SectionText>
      Connect your Bumper account once. Then ask your assistant to decode a VIN,
      check accident history, or pull market value, all from chat.
    </SectionText>
    <ClientGrid>
      {MCP_CLIENTS.map(({ id, label, available }) => (
        <ClientCard
          key={id}
          type="button"
          disabled={!available}
          onClick={onGetStartedClick}
          data-testid={`mcp-client-${id}`}
        >
          <ClientName>
            <McpClientIcon client={id} size={id === 'claude' ? 36 : 30} />
            {label}
          </ClientName>
          <StatusPill available={available}>
            {available ? 'Now available' : 'Coming soon'}
          </StatusPill>
        </ClientCard>
      ))}
    </ClientGrid>
    <CapabilitiesLabel>What your assistant can do</CapabilitiesLabel>
    {ASSISTANT_CAPABILITIES.map((item) => (
      <CapabilityRow key={item}>
        <Check color="success" sx={{ fontSize: 18, mt: '2px' }} aria-hidden />
        <CapabilityText>{item}</CapabilityText>
      </CapabilityRow>
    ))}
    <GetStartedButton
      type="button"
      onClick={onGetStartedClick}
      data-testid="mcp-get-started-button"
    >
      Get started
    </GetStartedButton>
  </HeroRoot>
);
